import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import Slider from 'react-slick';

import BlogDummy from '@/assets/images/blog-dummy.png';

import { BlogsData } from './BlogCarouselData';
import { BlogSchemaConfig } from './BlogSchema';

const BlogCarousel = () => {
  return (
    <div className="blog-cards-containers">
      <Slider {...BlogSchemaConfig} className="blog-carousel">
        {BlogsData.map((blog, index) => {
          return (
            <div className="item mfone-scheme-card" key={index}>
              <div className="" key={blog.id}>
                <Link href={blog.url || '#'} className="blogs__card">
                  <div className="blogs__card-figures">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={blog.imageSrc || BlogDummy}
                      alt=""
                    />
                    {/* <div className="chips chips--lightBlack">{blog.chip}</div> */}
                  </div>
                  <div className="blogs__card-content card-height">
                    <p className="text--black text--bold title">
                      {blog.heading}
                    </p>
                    <p className="text--gray text--regular desc smallFont">
                      {blog.info}
                    </p>
                  </div>
                </Link>
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default BlogCarousel;
